module.exports = __webpack_public_path__ + "img/CATEGORY ICON-28.a621881e.png";